module.exports = __webpack_public_path__ + "fonts/himalia_80a98625a0ec2841d5d7b85f650cf861.ttf";